// Organization Info Section - Name and domain fields
import React from 'react';
import { FormSection, FormField } from '@/components/common/admin/form';

interface OrganizationInfoSectionProps {
  name: string;
  domain: string;
  nameError?: string;
  domainError?: string;
  onNameChange: (value: string) => void;
  onDomainChange: (value: string) => void;
  disabled?: boolean;
}

export const OrganizationInfoSection: React.FC<OrganizationInfoSectionProps> = ({
  name,
  domain,
  nameError,
  domainError,
  onNameChange,
  onDomainChange,
  disabled,
}) => {
  return (
    <FormSection title="Information">
      <FormField
        label="Organization Name"
        value={name}
        onChangeText={onNameChange}
        placeholder="Enter organization name"
        error={nameError}
        required
        editable={!disabled}
      />

      <FormField
        label="Domain"
        value={domain}
        onChangeText={(text) => onDomainChange(text.toLowerCase())}
        placeholder="e.g., my-organization"
        autoCapitalize="none"
        error={domainError}
        helpText="Use lowercase letters, numbers, and hyphens only"
        required
        editable={!disabled}
      />
    </FormSection>
  );
};

